import * as React from 'react';
import { cn } from 'lib/utils';

export interface RowProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Enable flexbox wrapping (default: true) */
  wrap?: boolean;
  /** Alignment along main axis */
  justify?: 'start' | 'center' | 'end' | 'between' | 'around' | 'evenly';
  /** Alignment along cross axis */
  align?: 'start' | 'center' | 'end' | 'stretch' | 'baseline';
}

const justifyClasses = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
  evenly: 'justify-evenly',
};

const alignClasses = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
  baseline: 'items-baseline',
};

/**
 * Row component - provides flexbox row layout
 *
 * @see {@link ./row.md} For full documentation and examples
 */
const Row = React.forwardRef<HTMLDivElement, RowProps>(
  ({ className, wrap = true, justify, align, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex',
          wrap && 'flex-wrap',
          justify && justifyClasses[justify],
          align && alignClasses[align],
          className
        )}
        {...props}
      />
    );
  }
);
Row.displayName = 'Row';

export { Row };
